import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ProcessRestrictionResult, Restriction } from './restriction';
import { Document } from '../../../services/documents/documents';
import { BaseService } from 'src/app/common/base/base.service';

@Injectable({
  providedIn: 'root'
})
export class RestrictionService extends BaseService<Restriction, number> {

  constructor(protected override injector: Injector) {
    super(injector, '/Restriction');
  }

  Read(): Observable<Restriction[]> {
    return this.http.get<Restriction[]>(this.URL);
  }

  CheckByLocationID(locationID: number): Observable<ProcessRestrictionResult> {
    return this.http.get<ProcessRestrictionResult>(this.URL + '/CheckByLocation/' + locationID);
  }


}
